import { Flex, xcss } from '@atlaskit/primitives';
import { AccordionItemHeader } from './accordion-item-header';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const accordionBoxBorderStyles = xcss({
  width: '100%',
  borderBottom: "1px solid ".concat("var(--ds-border, rgba(9, 30, 66, 0.14))"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
  ':last-child': {
    borderBottom: 'none'
  }
});
export const AccordionItem = _ref => {
  let {
    renderHeader,
    expandItem,
    collapseItem,
    isExpanded,
    children,
    itemKey,
    testId,
    ariaLabel
  } = _ref;
  const togglePanel = () => {
    if (isExpanded) {
      collapseItem(itemKey);
    } else {
      expandItem(itemKey);
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    direction: "column",
    xcss: accordionBoxBorderStyles,
    testId: testId,
    children: [/*#__PURE__*/_jsx(AccordionItemHeader, {
      togglePanel: togglePanel,
      isPanelOpen: isExpanded,
      renderHeader: renderHeader,
      ariaLabel: ariaLabel,
      itemKey: itemKey
    }), isExpanded ? children : null]
  });
};